// FT-079: per-device + per-account состояние post-login passkey-nudge (localStorage) + чистое решение показа.
// Passkey привязан к паре (устройство + аккаунт) → «показан/отклонён/добавлен» храним per-device и
// СКОУПИМ по userId, чтобы активность одного аккаунта не глушила подсказку у другого на том же браузере.
const KEY_PREFIX = "passkey_nudge_v1";
export const NUDGE_CAP = 3;

// Ключ с привязкой к аккаунту; без userId — legacy общий ключ (обратная совместимость / фолбэк).
function keyFor(userId) {
  return userId ? `${KEY_PREFIX}_${userId}` : KEY_PREFIX;
}

export function readNudgeState(userId = null) {
  try {
    return JSON.parse(localStorage.getItem(keyFor(userId))) || {};
  } catch {
    return {};
  }
}

function writeNudgeState(userId, patch) {
  const next = { ...readNudgeState(userId), ...patch };
  try {
    localStorage.setItem(keyFor(userId), JSON.stringify(next));
  } catch {
    /* localStorage недоступен (приватный режим) — тихо игнорируем */
  }
  return next;
}

// Чистое решение — тестируется инъекцией state/контекста, без localStorage.
// platformAvailable: есть Face ID/отпечаток/Windows Hello (isPlatformAuthenticatorAvailable).
// lastLoginMethod: 'password' | 'otp' | 'passkey' — после passkey не предлагаем.
// sessionShown: уже показывали в этой сессии (макс 1 раз/сессию).
// userId: аккаунт для скоупинга состояния (если state не передан явно).
export function shouldShowNudge({
  platformAvailable = false,
  lastLoginMethod = null,
  sessionShown = false,
  state = null,
  userId = null,
} = {}) {
  const s = state || readNudgeState(userId);
  if (!platformAvailable) return false;
  if (lastLoginMethod === "passkey") return false;
  if (s.enrolledHere) return false;
  if (s.dismissedForever) return false;
  if ((s.shownCount || 0) >= NUDGE_CAP) return false;
  if (sessionShown) return false;
  return true;
}

export function markNudgeShown(userId = null) {
  const s = readNudgeState(userId);
  return writeNudgeState(userId, { shownCount: (s.shownCount || 0) + 1 });
}

// Вызвать после успешного добавления/использования passkey этим аккаунтом на этом устройстве → больше не предлагаем.
export function markEnrolledHere(userId = null) {
  return writeNudgeState(userId, { enrolledHere: true });
}

// «Больше не предлагать».
export function markDismissedForever(userId = null) {
  return writeNudgeState(userId, { dismissedForever: true });
}
